<template>
  <div class="contact-us full-screen">
    <div class="wrapper wrapper-full-page section content bg-secondary" style="overflow-y:auto;">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <div class="mt-5 d-flex justify-content-center">
              <div class="card">
                <div class="card-body">
                  <h1 class="card-title mb-3 text-center" style="font-size: 1.75em;">Δημιουργία λογαριασμού Kodiko</h1>
                  <div class="text-success text-center mb-3">Δωρεάν 7 ημέρες και 5 ερωτήσεις στο Kodiko Assistant<br>για να δοκιμάσετε τις συνδρομητικές υπηρεσίες του Kodiko</div>
                  <div class="form-group">
                    <label class="control-label" for="firstname_input">Όνομα</label>
                    <input class="form-control" id="firstname_input" type="text" v-model.trim="firstName" required>
                  </div>
                  <div class="form-group">
                    <label class="control-label" for="lastname_input">Επώνυμο</label>
                    <input class="form-control" id="lastname_input" type="text" v-model.trim="lastName" required>
                  </div>
                  <div class="form-group">
                    <label class="control-label" for="email_input">Email</label>
                    <input class="form-control" id="email_input" type="email" v-model.trim="email" required>
                    <span class="text-muted">(θα σας αποστείλουμε επιβεβαιωτικό email, βεβαιωθείτε ότι το πληκτρολογήσατε σωστά)</span>
                  </div>
                  <div class="form-group">
                    <label class="control-label" for="password_input">Κωδικός</label>
                    <input class="form-control" id="password_input" type="password" autocomplete="off" v-model.trim="password" required>
                    <span class="text-muted">(εισάγετε τον κωδικό που επιθυμείτε, με τουλάχιστον 6 χαρακτήρες)</span>
                  </div>
                  <div class="form-group">
                    <label class="control-label" for="password2_input">Επαλήθευση κωδικού</label>
                    <input class="form-control" id="password2_input" type="password" autocomplete="off" v-model.trim="password2" required>
                    <span class="text-muted">(εισάγετε τον ίδιο κωδικό με παραπάνω, για επαλήθευση)</span>
                  </div>
                </div>
                <div class="card-footer">
                  <div class="text-center">
                    <button class="btn btn-block btn-success" @click="register" :disabled="loading">Εγγραφη<span v-if="loading">...</span></button>
                    <div v-if="errorMsg !== ''" class="text-danger mt-1">{{ errorMsg }}</div>
                  </div>
                  <div class="text-center mt-4">
                    <div class=""><router-link :to="{path:'/login'}">σύνδεση στο λογαριασμό μου</router-link></div>
                  </div>
                  <div class="text-center mt-4">
                    <div class=""><a href="https://www.kodiko.gr">&larr;&nbsp;Επιστροφή στη Νομοθεσία</a></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../api";
export default {
  name: "register",
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      password2: "",
      errorMsg: "",
      loading: false
    };
  },
  methods: {
    register () {
      this.errorMsg = "";
      if (this.firstName === "" || this.lastName === "" || this.email === "" || this.password === "") {
        this.errorMsg = "Όλα τα πεδία είναι υποχρεωτικά";
        return false;
      }
      if (this.password2 !== this.password) {
        this.errorMsg = "Ο κωδικός επαλήθευσης δεν είναι ο ίδιος";
        return false;
      }

      this.loading = true;
      Api.send("POST", "/user/register", {firstName: this.firstName, lastName: this.lastName, email: this.email, password: this.password})
      .then((response) => {
        this.errorMsg = "";
        this.$router.push({name: 'register_success'})
      })
      .catch((err) => {
        this.errorMsg = err.msg;
      })
      .finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style></style>
